import api from '@js/actions/api';

const rideShareMapModule = {
    // _rideShareModel: {
    // },

    getSharedRide(doneCallback) {
        const urlParams = new URLSearchParams(window.location.search);
        const sharedUrl = urlParams.get(
            'share'
        );
        const copiedRideId = urlParams.get(
            'ride_id'
        );

        if (!sharedUrl && !copiedRideId) {
            return false;
        }

        this._fetchRidesTracks(sharedUrl, copiedRideId, doneCallback);

        return true;
    },

    /* Private Methods
    ******************** */
    _fetchRidesTracks(sharedUrl, copiedRideId, doneCallback) {
        const requestParam = {
            filter: {
                share_url: sharedUrl,
                ride_id: copiedRideId
            }
        };

        api.get('/api/v1/rides/shared-tracks', requestParam)
            .then((rideData) => {
                if (!rideData || !rideData.tracks) {
                    return;
                }

                this._mapModel.initialPoints = rideData.tracks.map((point) => ({
                    computed: point.point === 'auto',
                    latitude: point.latitude,
                    longitude: point.longitude,
                    deltaDistance: point.delta_distance,
                    elevation: point.elevation,
                    // deltaPause: null,
                    // deltaTime: null,
                    // datetime: null,
                    // speed: null,
                    // heartRate: null
                }));

                if (typeof doneCallback === 'function') {
                    doneCallback(copiedRideId ? 'copied' : 'share', rideData.name);
                }
            });
    }
};

export default rideShareMapModule;
